import { useLazyQuery } from '@apollo/react-hooks';
import React, { useEffect, useState, useRef, useContext } from 'react';
import { LuiSearchBar } from '@jda/lui-common-component-library';
import _ from 'lodash';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Box,
  Button,
  DialogActions,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Tabs,
  Tab,
  Paper
} from '@material-ui/core';
import { NetworkStatus } from '@apollo/client';
import ArrowChevronDown from '@jda/lui-common-icon-library/ui/ArrowChevronDown';
import ArrowDown from '@jda/lui-common-icon-library/ui/ArrowDown';
import ArrowUp from '@jda/lui-common-icon-library/ui/ArrowUp';
import { Loading } from '../../Loading';
import { StateContext } from '../../App';
import { formatString, Accordion, AccordionDetails, AccordionSummary } from '../../utils/helpers';
import JsonEditor from '../../components/JsonEditor';
import { useStyles } from './style';
import DetailedTable from '../../components/DetailedTable';
import { ingestionColumns, EventTypeConfig, searchColumns, subcolumns } from './columns';
import { ERROR_DIAGNOSIS_QUERY_FT_EVENTS_AUDITS } from '../graphQL/queries';
import { getCategory } from './config';

interface ManageRelationsProps {
  dialogOpen: true | false;
  handleDialogClose: any;
  formData?: any;
  mode: any;
  participantCode: any;
  startDate: any;
  endDate: any;
  rowData: any;
  tableId: any;
}

const AuditDetailsDialog = (props: ManageRelationsProps) => {
  const classes = useStyles();
  const state = useContext(StateContext);
  const [request, setRequest] = useState({});
  const [value, setValue] = useState('allLogs');
  const [order, setOrder] = useState<string>('asc');
  const [event, setEvent] = useState<any>({});
  const [ftMsg, setFTmsg] = useState({});
  const [trackingMsgPushed, setTrackingMsgPushed] = useState({});
  const [shipmentLoadMsg, setShipmentLoadMsg] = useState({});
  const [shipmentLoadSent, setShipmentLoadSent] = useState({});
  const [failedMsg, setFailedMsg] = useState({});
  const [isFTMsgFound, setFTMsgFound] = useState<any>(false);
  const [isGroupedBy, setIsGroupedBy] = useState<any>(false);
  const [isShipmentLoadMsgFound, setShipmentLoadMsgFound] = useState<any>(false);
  const [isShipmentLoadSentFound, setShipmentLoadSentFound] = useState<any>(false);
  const [inputText, setInputText] = useState<any>('');
  const [auditData, setAuditData] = useState<any>([]);
  const [ingestionIdData, setIngestionIdData] = useState<any>([]);
  const [type, setType] = useState('all');
  const [isFailedFound, setIsFailedFound] = useState<any>(false);

  const getJSONStatus = (rowData: any) => {
    try {
      JSON.parse(rowData);
      return true;
    } catch (err) {
      return false;
    }
  };

  const handleSpecClick = (specData: any) => {
    const specJSON = formatString(specData.eventMessage);
    setFTMsgFound(true);
    setFTmsg(specJSON);
  };

  const handleIngestionSpecClick = (specData: any) => {
    setFTMsgFound(false);
    setFTmsg({});
    setTrackingMsgPushed({});
    setIsFailedFound(false);
    setEvent(specData);
  };

  let search: any = {};
  search.loadId = props?.rowData?.id;
  search.shipmentId = props?.rowData?.shipmentId;
  if (type !== 'all') search.eventType = type;

  search = Object.keys(search)
    .map(key => {
      return key + '=' + search[key];
    })
    .join(';');

  const [
    getFreightEvents,
    { loading: freightLoading, data: freightData, networkStatus: freightNetworkStatus }
  ] = useLazyQuery(ERROR_DIAGNOSIS_QUERY_FT_EVENTS_AUDITS, {
    variables: {
      participantCode: props.participantCode,
      // startDate: props.startDate,
      // endDate: props.endDate,
      search: search,
      size: state?.userPreferences?.[props.tableId]?.rowsPerPage || 50,
      page: state?.userPreferences?.[props.tableId]?.page || 0
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  });

  React.useEffect(() => {
    getFreightEvents();
    setRequest({});
    loadIngestionIdData();
  }, [props.formData.id, value, type]);

  const loadIngestionIdData = () => {
    const AuditEventTypeList: any = [];
    const AuditGroupedByList: any = [];
    const groupedByData = freightData?.errorDiagnosisFTEventsAudits?.content
      ? groupBy(freightData?.errorDiagnosisFTEventsAudits?.content, 'ingestionId')
      : [];
    if (value === 'groupById') {
      const ingestionData = Object.keys(groupedByData).map((key: string) => {
        const rowData = {
          ingestionId: key,
          eventsCategory: _.uniqBy(
            groupedByData[key].map((res: any) => getCategory(res.eventType)?.toString()),
            (e: any) => e
          ).toString(),
          eventTime: groupedByData[key][0].eventTime,
          eventMessages: groupedByData[key].map((data: any) => {
            return {
              eventTime: data?.eventTime,
              eventMessage: data?.eventMessage || '',
              eventType: data?.eventType
            };
          })
        };
        return rowData;
      });
      setIngestionIdData(ingestionData);
    } else {
      _.keys(groupedByData || []).forEach(key => {
        const eventTypeList: any = [];
        var temp1;
        var temp4: any = {};
        _.keys(groupedByData[key] || []).forEach(key1 => {
          var eventKey = groupedByData[key]?.[key1]?.eventType;
          if (eventKey) {
            temp1 = {
              eventType: groupedByData[key]?.[key1]?.eventType,
              eventTime: groupedByData[key]?.[key1]?.eventTime,
              eventMessage: groupedByData[key]?.[key1]?.eventMessage
            };
            eventTypeList.push(temp1);
          }
          temp4 = {
            eventType: eventTypeList
          };
        });
        AuditEventTypeList.push(temp4);
      });

      _.keys(AuditEventTypeList || []).forEach(key => {
        _.keys(AuditEventTypeList[key] || []).forEach(key1 => {
          var status;
          var category;
          var time;
          var shipmentIngestion;
          var shipmentSent;
          var shipmentFailed;
          let message: any = [];
          const msg: any = {};
          var BreakException = {};
          try {
            _.keys(AuditEventTypeList[key]?.[key1] || []).forEach(key2 => {
              if (
                AuditEventTypeList[key]?.[key1]?.[key2]?.eventType === 'LoadCreated' ||
                AuditEventTypeList[key]?.[key1]?.[key2]?.eventType === 'LoadUpdated' ||
                AuditEventTypeList[key]?.[key1]?.[key2]?.eventType === 'ExternalPartnerRequestResponse'
              ) {
                category = 'Tracking Initiation';
                time = AuditEventTypeList[key]?.[key1]?.[key2]?.eventTime;
                throw BreakException;
              } else if (
                AuditEventTypeList[key]?.[key1]?.[key2]?.eventType === 'TrackingMessageCreated' ||
                AuditEventTypeList[key]?.[key1]?.[key2]?.eventType === 'TrackingMessagePushedFromPartner'
              ) {
                category = 'Tracking Update';
                time = AuditEventTypeList[key]?.[key1]?.[key2]?.eventTime;
                throw BreakException;
              } else {
                category = 'Unknown';
                time = AuditEventTypeList[key]?.[key1]?.[key2]?.eventTime;
              }
            });
          } catch (e) {
            if (e !== BreakException) throw e;
          }

          try {
            _.keys(AuditEventTypeList[key]?.[key1] || []).forEach(key2 => {
              if (
                AuditEventTypeList[key]?.[key1]?.[key2]?.eventType === 'RouterSendingMessageToStackSuccess' ||
                AuditEventTypeList[key]?.[key1]?.[key2]?.eventType === 'LoadCreatedInPartnerSystem' ||
                AuditEventTypeList[key]?.[key1]?.[key2]?.eventType === 'LoadUpdatedInPartnerSystem'
              ) {
                status = 'Success';
                throw BreakException;
              } else if (AuditEventTypeList[key]?.[key1]?.[key2]?.eventType === 'RouterSendingMessageToStackFailed') {
                status = 'Failed';
                throw BreakException;
              } else {
                status = 'Unknown';
              }
            });
          } catch (e) {
            if (e !== BreakException) throw e;
          }

          try {
            _.keys(AuditEventTypeList[key]?.[key1] || []).forEach(key2 => {
              if (AuditEventTypeList[key]?.[key1]?.[key2]?.eventType === 'SendingEnrichedMessageToRouter') {
                msg['ftMsg'] = AuditEventTypeList[key]?.[key1]?.[key2]?.eventMessage;
              } else if (
                AuditEventTypeList[key]?.[key1]?.[key2]?.eventType === 'LoadCreated' ||
                AuditEventTypeList[key]?.[key1]?.[key2]?.eventType === 'LoadUpdated'
              ) {
                msg['shipmentLoadMsg'] = AuditEventTypeList[key]?.[key1]?.[key2]?.eventMessage;
              } else if (AuditEventTypeList[key]?.[key1]?.[key2]?.eventType === 'ExternalPartnerRequestResponse') {
                msg['shipmentLoadSent'] = AuditEventTypeList[key]?.[key1]?.[key2]?.eventMessage;
              } else if (AuditEventTypeList[key]?.[key1]?.[key2]?.eventType === 'RouterSendingMessageToStackFailed') {
                msg['failedMsg'] = AuditEventTypeList[key]?.[key1]?.[key2]?.eventMessage;
              } else if (AuditEventTypeList[key]?.[key1]?.[key2]?.eventType === 'TrackingMessagePushedFromPartner') {
                msg['trackingMsgPushed'] = AuditEventTypeList[key]?.[key1]?.[key2]?.eventMessage;
              }
            });
          } catch (e) {
            if (e !== BreakException) throw e;
          }
          message.push(msg);
          const obj = {
            eventCategory: category,
            eventStatus: status,
            eventTime: time,
            eventMessage: message,
            shipmentIngestion: shipmentIngestion,
            shipmentSent: shipmentSent,
            shipmentFailed: shipmentFailed
          };
          AuditGroupedByList.push(obj);
        });
      });
      setIngestionIdData(AuditGroupedByList);
    }
  };

  const onSearchChange = (searchKey: string) => {
    const { search } = searchKey;
    setInputText(search.toString());
    const participantResult = freightData?.errorDiagnosisFTEventsAudits?.content;
    const filteredData = participantResult?.filter((row: any) => {
      return String(searchColumns.map(column => String(row[column]).toLowerCase())).includes(
        search.toString().toLowerCase()
      );
    });
    setAuditData(filteredData);
  };

  const groupBy = (objectArray: any, property: any) => {
    return objectArray?.reduce((acc: any, obj: any) => {
      const key = obj[property];
      if (key) {
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(obj);
      }
      return acc;
    }, {});
  };

  const onClearText: any = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    setInputText('');
    setAuditData(freightData?.errorDiagnosisFTEventsAudits?.content);
  };

  const jsonRequestEditorRef = useRef<any>();
  const jsonFTMsgEditorRef = useRef<any>();
  const jsonShipmentLoadMsgEditorRef = useRef<any>();
  const jsonShipmentLoadSentEditorRef = useRef<any>();
  const jsonFailedMsgEditorRef = useRef<any>();
  const jsonTrackingMessagePushedFromPartnerEditorRef = useRef<any>();
  useEffect(() => {
    if (jsonRequestEditorRef && jsonRequestEditorRef.current) {
      jsonRequestEditorRef.current.set(request);
      jsonRequestEditorRef.current.expandAll && jsonRequestEditorRef.current.expandAll();
    }
  }, [request]);

  const setRequestEditorRef = (instance: any) => {
    if (instance) {
      jsonRequestEditorRef.current = instance.jsonEditor;
    } else {
      jsonRequestEditorRef.current = null;
    }
  };

  useEffect(() => {
    if (jsonFailedMsgEditorRef && jsonFailedMsgEditorRef.current) {
      jsonFailedMsgEditorRef.current.set(failedMsg);
      jsonFailedMsgEditorRef.current.expandAll && jsonFailedMsgEditorRef.current.expandAll();
    }
  }, [failedMsg]);

  const setFailedMsgEditorRef = (instance: any) => {
    if (instance) {
      jsonFailedMsgEditorRef.current = instance.jsonEditor;
    } else {
      jsonFailedMsgEditorRef.current = null;
    }
  };

  useEffect(() => {
    if (jsonFTMsgEditorRef && jsonFTMsgEditorRef.current) {
      jsonFTMsgEditorRef.current.set(ftMsg);
      jsonFTMsgEditorRef.current.expandAll && jsonFTMsgEditorRef.current.expandAll();
    }
  }, [ftMsg]);

  const setJsonFTMsgEditorRef = (instance: any) => {
    if (instance) {
      jsonFTMsgEditorRef.current = instance.jsonEditor;
    } else {
      jsonFTMsgEditorRef.current = null;
    }
  };

  const trackingMessagePushedFromPartnerRef = (instance: any) => {
    if (instance) {
      jsonTrackingMessagePushedFromPartnerEditorRef.current = instance.jsonEditor;
    } else {
      jsonTrackingMessagePushedFromPartnerEditorRef.current = null;
    }
  };

  useEffect(() => {
    if (jsonShipmentLoadMsgEditorRef && jsonShipmentLoadMsgEditorRef.current) {
      jsonShipmentLoadMsgEditorRef.current.set(shipmentLoadMsg);
      jsonShipmentLoadMsgEditorRef.current.expandAll && jsonShipmentLoadMsgEditorRef.current.expandAll();
    }
  }, [shipmentLoadMsg]);

  const setJsonShipmentLoadMsgEditorRef = (instance: any) => {
    if (instance) {
      jsonShipmentLoadMsgEditorRef.current = instance.jsonEditor;
    } else {
      jsonShipmentLoadMsgEditorRef.current = null;
    }
  };

  useEffect(() => {
    if (jsonShipmentLoadSentEditorRef && jsonShipmentLoadSentEditorRef.current) {
      jsonShipmentLoadSentEditorRef.current.set(shipmentLoadSent);
      jsonShipmentLoadSentEditorRef.current.expandAll && jsonShipmentLoadSentEditorRef.current.expandAll();
    }
  }, [shipmentLoadSent]);

  const setJsonShipmentLoadSentEditorRef = (instance: any) => {
    if (instance) {
      jsonShipmentLoadSentEditorRef.current = instance.jsonEditor;
    } else {
      jsonShipmentLoadSentEditorRef.current = null;
    }
  };

  const handleChangeType = (e: any) => {
    const selectType = e.target.value;
    if (selectType === 'ingestionId') {
      setIsGroupedBy(true);
    } else {
      setFTMsgFound(false);
      setShipmentLoadMsgFound(false);
      setShipmentLoadSentFound(false);
      setIsFailedFound(false);
      setIsGroupedBy(false);
    }
    setType(selectType);
    setRequest({});
    setFTmsg({});
    setShipmentLoadMsg({});
    setShipmentLoadSent({});
    setFailedMsg({});
    setIngestionIdData({});
  };

  const handleEventDialogClose = () => {
    props.handleDialogClose();
    setRequest({});
    setFTmsg({});
    setShipmentLoadMsg({});
    setShipmentLoadSent({});
    setFailedMsg({});
    setType('all');
    setIngestionIdData({});
    setFTMsgFound(false);
    setShipmentLoadMsgFound(false);
    setShipmentLoadSentFound(false);
    setIsFailedFound(false);
    setIsGroupedBy(false);
  };

  const TabPanel = (props: any) => {
    const { children, value, index } = props;

    return (
      <Typography component="div" role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`}>
        {value === index && <Box>{children}</Box>}
      </Typography>
    );
  };

  const handleChange = (_event: React.ChangeEvent<{}>, newValue: string) => {
    setFTmsg({});
    setFTMsgFound(true);
    setTrackingMsgPushed({});
    setValue(newValue);
  };

  const onChange = (event: any) => {
    let query: any = {};
    query.search = event.target.value;
    onSearchChange(query);
  };

  return (
    <Dialog onClose={props.handleDialogClose} open={props.dialogOpen} fullWidth={true} maxWidth="xl">
      <DialogTitle id="customized-dialog-title">View Audit Details</DialogTitle>
      <DialogContent dividers>
        <Paper>
          <Tabs data-id="tabs" value={value} onChange={handleChange}>
            <Tab label={'All Logs'} className={classes.tab} value="allLogs" />
            <Tab
              label={'Group By ID'}
              className={classes.tab}
              value="groupById"
              disabled={freightLoading || freightNetworkStatus === NetworkStatus.refetch}
            />
          </Tabs>
          <TabPanel value={value} index="allLogs">
            <Grid container>
              <Grid item xs={4}>
                <FormControl required={true} className={classes.selectField}>
                  <InputLabel id="event-dialog-eventType-label">Event Type</InputLabel>
                  <Select
                    data-id="event-type-id"
                    id="event-type-id"
                    className={classes.textField}
                    value={type}
                    onChange={e => handleChangeType(e)}
                  >
                    <MenuItem value={EventTypeConfig.All.value}>{EventTypeConfig.All.label}</MenuItem>
                    <MenuItem value={EventTypeConfig.ExternalPartner.value}>
                      {EventTypeConfig.ExternalPartner.label}
                    </MenuItem>
                    <MenuItem value={EventTypeConfig.TrackingMessage.value}>
                      {EventTypeConfig.TrackingMessage.label}
                    </MenuItem>
                    <MenuItem value={EventTypeConfig.MessageToRouter.value}>
                      {EventTypeConfig.MessageToRouter.label}
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            {freightLoading || freightNetworkStatus === NetworkStatus.refetch ? (
              <Loading />
            ) : (
              <Grid container justify="space-between" spacing={2}>
                <Grid item xs={6}>
                  {type === 'all' && (
                    <LuiSearchBar
                      autoFocus={true}
                      value={inputText}
                      onChange={onChange}
                      onClear={onClearText}
                      placeholder={'Search'}
                      className={classes.searchBar}
                    />
                  )}
                  <DetailedTable
                    key="auditInfo"
                    id={props.tableId || 'auditGrid'}
                    title={'Audit Details'}
                    data={inputText === '' ? freightData?.errorDiagnosisFTEventsAudits?.content || [] : auditData}
                    columns={
                      type === 'ingestionId' ? ingestionColumns : subcolumns(type, getJSONStatus, handleSpecClick)
                    }
                    inputText={type === 'all' ? inputText : ''}
                    actionsColumnIndex={0}
                    showPagination={true}
                    serverPagination={true}
                    count={freightData?.errorDiagnosisFTEventsAudits?.totalElements}
                    rowsPerPage={10}
                    tableActions={[]}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="button">{'FT Message'}</Typography>
                  <JsonEditor
                    setRef={setJsonFTMsgEditorRef}
                    id={`jsonRequestEditor2-${props?.formData?.eventId}`}
                    data={ftMsg}
                    mode={props.mode}
                  />
                </Grid>
                {isShipmentLoadMsgFound && (
                  <Grid item xs={6}>
                    <Typography variant="button">{'Shipment/Load message'}</Typography>
                    <JsonEditor
                      setRef={setJsonShipmentLoadMsgEditorRef}
                      id={`jsonRequestEditor3-${props?.formData?.eventId}`}
                      data={shipmentLoadMsg}
                      mode={props.mode}
                    />
                  </Grid>
                )}
                {isShipmentLoadSentFound && (
                  <Grid item xs={5}>
                    <Typography variant="button">{'Shipment/Load sent to Partner'}</Typography>
                    <JsonEditor
                      setRef={setJsonShipmentLoadSentEditorRef}
                      id={`jsonRequestEditor4-${props?.formData?.eventId}`}
                      data={shipmentLoadSent}
                      mode={props.mode}
                    />
                  </Grid>
                )}
                {isFailedFound && (
                  <Grid item xs={5}>
                    <Typography variant="button">{'Failure details'}</Typography>
                    <JsonEditor
                      setRef={setFailedMsgEditorRef}
                      id={`jsonRequestEditor5-${props?.formData?.eventId}`}
                      data={failedMsg}
                      mode={props.mode}
                    />
                  </Grid>
                )}
              </Grid>
            )}
          </TabPanel>
          <TabPanel value={value} index="groupById">
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <DetailedTable
                  key="groupById"
                  id={props.tableId || 'auditGrid'}
                  title={'Group By Ingestion ID Details'}
                  data={ingestionIdData || []}
                  columns={ingestionColumns(classes, handleIngestionSpecClick)}
                  onClearText={onClearText}
                  actionsColumnIndex={0}
                  tableActions={[]}
                />
              </Grid>
              <Grid item xs={6}>
                {event?.ingestionId && (
                  <Typography variant="h6" style={{ margin: '10px', textDecoration: 'underline' }}>
                    Events of "{event?.ingestionId}"{' '}
                    {order === 'asc' ? (
                      <ArrowDown onClick={() => setOrder('desc')} className={classes.arrow} />
                    ) : (
                      <ArrowUp onClick={() => setOrder('asc')} className={classes.arrow} />
                    )}
                  </Typography>
                )}
                {_.orderBy(event?.eventMessages, 'eventTime', order === 'asc' ? 'asc' : 'desc')?.map((msg: any) => (
                  <Accordion elevation={0} onChange={() => {}}>
                    <AccordionSummary
                      expandIcon={<ArrowChevronDown color="inherit" />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      style={{ backgroundColor: '#fff', margin: 0 }}
                    >
                      <Typography>
                        Event Time: {msg.eventTime}, Event Name: {msg.eventType}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid item xs={12}>
                        <JsonEditor
                          data-id="transform-spec-editor"
                          setRef={setRequestEditorRef}
                          data={formatString(msg.eventMessage)}
                          view={false}
                          mode="code"
                          id={'JsonEditorSpec'}
                          allowedModes={['code', 'tree']}
                          theme="ace/theme/github"
                          htmlElementProps={{
                            style: {
                              height: '60vh',
                              width: '100%'
                            }
                          }}
                        />
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </Grid>
            </Grid>
          </TabPanel>
        </Paper>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleEventDialogClose} color="primary" variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default AuditDetailsDialog;
